import { render, staticRenderFns } from "./VideoPlayerLimited.vue?vue&type=template&id=ff90e6dc"
import script from "./VideoPlayerLimited.vue?vue&type=script&lang=js"
export * from "./VideoPlayerLimited.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports